/* esm.sh - react-router-dom@7.15.1 */
import{HydratedRouter as o,RouterProvider as e}from"react-router/dom";export*from"react-router";export{o as HydratedRouter,e as RouterProvider};
/*! Bundled license information:

react-router-dom/dist/index.mjs:
  (**
   * react-router-dom v7.15.1
   *
   * Copyright (c) Remix Software Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   *)
*/
//# sourceMappingURL=react-router-dom.mjs.map